import { isNullOrUndefinedOrEmpty } from '@/utils/helpers';

export default {
	computed: {
		isValid() {
			const placementData = this.getToolPlacementData();
			if (!this.$options.requiredFields) {
				throw new Error(`Error in [ToolPlacementDataMixin]. requiredFields weren't provided in [${this.$options.name}]`);
			}
			return this.$options.requiredFields.every((requiredField) => !isNullOrUndefinedOrEmpty(placementData[requiredField]));
		},
	},
	methods: {
		/**
		 * this method meant to be implemented by each ToolPlacementData component
		 * Used by FillToolData to collect the data from the specific tool type data component
		 *
		 * it's only use here is for self enforcement - so we won't forget to override it by component itself
		 */
		getToolPlacementData() {
			throw new Error(`getToolPlacementData wasn't implemented by [${this.$options.name}]`);
		},
		setIsValid(valid) {
			this.$emit('is-valid', valid);
		},
	},
	watch: {
		isValid: {
			handler(newV) {
				this.setIsValid(newV);
			},
			immediate: true,
		},
	},
};
